import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import {Row, Column} from '../../global/grid/grid';

import colors from '../../../vars/colors';
import { TickerWrapper } from './styled-components';

@inject("store")
@observer class Ticker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dials: null,
      active: false,
    }

    this.scrollPoint = null;
    this.tickerRow = null;

    this.handleScroll = this.handleScroll.bind(this);
    this.setScrollPoint = this.setScrollPoint.bind(this);
    this.getPosition = this.getPosition.bind(this);
    this.setTickerRow = this.setTickerRow.bind(this);
  }
  componentDidMount() {
    const { store } = this.props;
    const { number } = this.props.data;
    if(store.os.name === 'ios') {
      this.setState({
        dials: <span>{number}</span>
      });
    } else {
      this.getDialNumbers(number);
    }
    document.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.setScrollPoint);
  }
  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.setScrollPoint);
  }
  shouldComponentUpdate() {
    return true
  }
  setTickerRow(el) {
    if(el) {
      this.tickerRow = el;
      this.setScrollPoint();
    }
  }
  setScrollPoint() {
    setTimeout(() => {
      const scrollTop = document.documentElement ? document.documentElement.scrollTop : document.body.scrollTop;
      // const tickerTop = this.tickerRow.getBoundingClientRect().top;
      const tickerTop = this.getPosition(this.tickerRow);
      const tickerHeight = this.tickerRow.getBoundingClientRect().height;
      this.scrollPoint = tickerTop.y - window.innerHeight + (tickerHeight / 4);
    }, 300);
  }
  handleScroll(e) {
    const scrollY = window.scrollY ? window.scrollY : window.pageYOffset;
    if(this.scrollPoint < scrollY && !this.state.active) {
      this.setState({
        active: true
      });
    }
  }
  getPosition(element) {
    let xPosition = 0;
    let yPosition = 0;

    while(element) {
        xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft);
        yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
        element = element.offsetParent;
    }

    return { x: xPosition, y: yPosition };
}
  getDialNumbers(number) {
    const numberArray = number.split('');
    const dialNumbers = numberArray.map((element, index) => {
      let dial = [];
      const numberAsInt = parseInt(element);
      if(index !== 0) {
        for(let i = 0; i < ( (10 * index) + 1 ); i++) {
          let displayNum = numberAsInt + i;
          if(displayNum >= 10) {
            const stringNum = displayNum.toString();
            displayNum = stringNum[stringNum.length -1];
          }
          dial.push(displayNum);
        }
      } else {
        for(let i = 0; i <= numberAsInt; i++) {
          dial.push(i);
        }
      }
      return dial;
    });
    const dials = this.buildDials(dialNumbers);
    this.setState({
      dials: dials
    });
  }
  buildDials(dialNumbers) {
    const dials = dialNumbers.map((element, index) => {
      const comma = (index + 1 !== dialNumbers.length && ((dialNumbers.length - (index + 1)) % 3 === 0));
      return (
        <span key={index}>
          <div className={`dialWrapper`}>
            <div className="dial" style={{
              transitionDuration: `${1000 + (300 * (index + 1))}ms`,
            }}>
              { this.buildDial(element) }
            </div>
          </div>
          { comma &&
            <div className="comma">,</div>
          }
        </span>
      )
    });
    return dials;
  }
  buildDial(numbers) {
    const dial = numbers.map((number, index) => {
      return (
        <div className="dialNumber" key={index}>{number}</div>
      )
    });
    return dial.reverse();
  }
  render() {
    const { data } = this.props;

    return (
      <div ref={this.setTickerRow}>
        <Row margins>
          <Column cw={8} offset={2}>
            <TickerWrapper active={this.state.active} className={`${this.state.active ? 'active' : ''}`}>
              { data.numberType === 'money' &&
                <span>$</span>
              }
              <span className="fullText"><span className="number" style={{color: `${colors['lipstick']}`}}>{this.state.dials}</span> <span className="label">{data.label}</span></span>
            </TickerWrapper>
          </Column>
        </Row>
      </div>
    )
  }
}

export default Ticker;



// WEBPACK FOOTER //
// ./src/components/modules/Ticker/Ticker.js